import {
  getScoreDisplayValue,
  isScoreAvailable,
} from "../../formatting/domain-value-manipulation";
import type { Pillars } from "../../types";
import type { Field } from "../tabs/types";

export function getPillarScores(pillars?: Pillars): Array<number | undefined> {
  return [
    pillars?.carbon?.scores?.total,
    pillars?.biodiversity?.scores?.total,
    pillars?.people?.scores?.total,
  ];
}

export function getTotalScore(pillars?: Pillars): number | undefined {
  const pillarScores = getPillarScores(pillars);
  const hasAllPillarScores = pillarScores.every(isScoreAvailable);

  return hasAllPillarScores
    ? pillarScores.reduce((total, score) => total + score, 0) /
        pillarScores.length
    : undefined;
}

export function buildScoresFields(
  pillars?: Pillars,
  startIndex = 0,
): Array<Field> {
  const [carbonScore, biodiversityScore, peopleScore] =
    getPillarScores(pillars);

  return [
    {
      name: "Carbon:",
      type: "text",
      index: startIndex,
      value: getScoreDisplayValue(carbonScore),
    },
    {
      name: "Biodiversity:",
      type: "text",
      index: startIndex + 1,
      value: getScoreDisplayValue(biodiversityScore),
    },
    {
      name: "People:",
      type: "text",
      index: startIndex + 2,
      value: getScoreDisplayValue(peopleScore),
    },
    {
      name: "Total (derived when all 3 pillar scores are available):",
      type: "text",
      index: startIndex + 3,
      value: getScoreDisplayValue(getTotalScore(pillars)),
    },
  ];
}
